import { useEffect, useState } from 'react';
import api from '../api';
import { REGULAMIN_TEXT, PRYWATNOSC_TEXT } from './legal';

/**
 * Regulamin i polityka pobierane z backendu, z wersją wbudowaną jako zapasem.
 *
 * Po co backend: te same dokumenty żyły w pięciu kopiach w czterech repo i zdążyły się
 * rozjechać, a poprawka w mobilce wymagała pełnego cyklu recenzji w sklepie.
 *
 * Po co mimo to wersja wbudowana: regulamin musi być czytelny także wtedy, gdy API nie
 * odpowiada. Pusty ekran w tym miejscu to problem z art. 13 RODO, nie usterka kosmetyczna.
 */
const FALLBACK = {
  'client-terms': REGULAMIN_TEXT,
  'client-privacy': PRYWATNOSC_TEXT,
};

const cache = {};

export function useLegalDocument(key) {
  const [content, setContent] = useState(cache[key] || FALLBACK[key] || '');

  useEffect(() => {
    let aktualne = true;
    if (cache[key]) {
      setContent(cache[key]);
      return undefined;
    }
    api
      .get(`/api/v1/public/legal/${key}`)
      .then(({ data }) => {
        if (!data?.content) return;
        cache[key] = data.content;
        if (aktualne) setContent(data.content);
      })
      .catch(() => {
        // Zostaje wersja wbudowana.
      });
    return () => {
      aktualne = false;
    };
  }, [key]);

  return content;
}
